/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../magnolia/lib/MagnoliaPropertyHelper';

export interface switchableStruct {
  field ? : string;
  page: any;
  external: string;
}
export interface includePagesStruct {
  pageLink ? : any;
}
export interface excludePagesStruct {
  pageLink ? : any;
}
export default interface Banner {
  legalTitle ? : string;
  legalText ? : string;
  enableLegalDisclaimer ? : boolean;
  titleOrSubtitle ? : string;
  dataABId ? : string;
  isHidden ? : boolean;
  backgroundColor ? : number;
  textColor ? : number;
  discountCode ? : string;
  info ? : string;
  backgroundColorButton ? : number;
  textColorButton ? : number;
  borderColorButton ? : number;
  switchable ? : switchableStruct;
  showOnAllPages ? : boolean;
  showInPLP ? : boolean;
  showInPDP ? : boolean;
  showOnHome ? : boolean;
  showInCart ? : boolean;
  showInWishlist ? : boolean;
  showInAccountArea ? : boolean;
  showInAllContentPages ? : boolean;
  includePages ? : Array < includePagesStruct > ;
  excludePages ? : Array < excludePagesStruct > ;
  metadata ? : any;
}

export const Props = {
  legalTitle: String,
  legalText: String,
  enableLegalDisclaimer: Boolean,
  titleOrSubtitle: String,
  dataABId: String,
  isHidden: Boolean,
  backgroundColor: Number,
  textColor: Number,
  discountCode: String,
  info: String,
  backgroundColorButton: Number,
  textColorButton: Number,
  borderColorButton: Number,
  switchable: Object as() => switchableStruct,
  showOnAllPages: Boolean,
  showInPLP: Boolean,
  showInPDP: Boolean,
  showOnHome: Boolean,
  showInCart: Boolean,
  showInWishlist: Boolean,
  showInAccountArea: Boolean,
  showInAllContentPages: Boolean,
  includePages: Array as() => Array < includePagesStruct > ,
  excludePages: Array as() => Array < excludePagesStruct > ,
  metadata: Object,
}

export const WrapperProps = {
  legalTitle: String,
  legalText: String,
  enableLegalDisclaimer: Boolean,
  titleOrSubtitle: String,
  dataABId: String,
  isHidden: Boolean,
  backgroundColor: Number,
  textColor: Number,
  discountCode: String,
  info: String,
  backgroundColorButton: Number,
  textColorButton: Number,
  borderColorButton: Number,
  switchable: Object as() => switchableStruct,
  showOnAllPages: Boolean,
  showInPLP: Boolean,
  showInPDP: Boolean,
  showOnHome: Boolean,
  showInCart: Boolean,
  showInWishlist: Boolean,
  showInAccountArea: Boolean,
  showInAllContentPages: Boolean,
  includePages: Object,
  excludePages: Object,
  metadata: Object,
}

export class BannerBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class BannerInstance implements Banner {
      legalTitle ? : string;
      legalText ? : string;
      enableLegalDisclaimer ? : boolean;
      titleOrSubtitle ? : string;
      dataABId ? : string;
      isHidden ? : boolean;
      backgroundColor ? : number;
      textColor ? : number;
      discountCode ? : string;
      info ? : string;
      backgroundColorButton ? : number;
      textColorButton ? : number;
      borderColorButton ? : number;
      switchable ? : switchableStruct;
      showOnAllPages ? : boolean;
      showInPLP ? : boolean;
      showInPDP ? : boolean;
      showOnHome ? : boolean;
      showInCart ? : boolean;
      showInWishlist ? : boolean;
      showInAccountArea ? : boolean;
      showInAllContentPages ? : boolean;
      includePages ? : Array < includePagesStruct > ;
      excludePages ? : Array < excludePagesStruct > ;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.includePages) {
          this.includePages = Object.entries(this.includePages)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'includePages' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
        } else {
          this.includePages = null as any;
        }
        if (this.excludePages) {
          this.excludePages = Object.entries(this.excludePages)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'excludePages' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
        } else {
          this.excludePages = null as any;
        }
      }
    }
    return new BannerInstance(props);
  }
}
